import { render, staticRenderFns } from "./subdealer_index.vue?vue&type=template&id=68213317&scoped=true&"
import script from "./subdealer_index.vue?vue&type=script&lang=js&"
export * from "./subdealer_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68213317",
  null
  
)

export default component.exports